import { Field } from 'formik';

import FormField from './FormField';
import Datepicker from './Datepicker';

// If you need to extend Datepicker functionality keep in mind that {...props} is on FormControl to support all Chakra props
// Specific props for Datepicker should be excluded from ...props and manually added
const DateFormikField = ({
    id,
    name,
    label,
    isDisabled,
    value,
    onChange,
    onCalendarClose,
    maxDate,
    minDate,
    utc,
    dateFormat,
    showTimeInput,
    placeholderText,
    isClearable,
    showMonthYearPicker,
    autoComplete,
    ...props
}) => (
    <Field name={name}>
        {({ field, meta, form }) => (
            <FormField
                id={id}
                name={name}
                label={label}
                isDisabled={isDisabled}
                isInvalid={meta.error && meta.touched}
                error={meta.error}
                {...props}
            >
                <Datepicker
                    disabled={isDisabled}
                    showTimeInput={showTimeInput}
                    {...field} // {...field} also contains onChange, onCalendarClose, which we overwrite
                    onChange={(date) => {
                        const value = date || '';

                        form.setFieldValue(name, value);

                        // additional custom action could be hooked up with onChange callback
                        if (typeof onChange === 'function') {
                            onChange(value);
                        }
                    }}
                    onCalendarClose={() => {
                        form.setFieldTouched(name, true, false);

                        // additional custom action could be hooked up with onCalendarClose callback
                        if (typeof onCalendarClose === 'function') {
                            onCalendarClose();
                        }
                    }}
                    dateFormat={dateFormat}
                    placeholderText={placeholderText}
                    isClearable={isClearable}
                    maxDate={maxDate}
                    minDate={minDate}
                    utc={utc}
                    showMonthYearPicker={showMonthYearPicker}
                    autoComplete={autoComplete}
                />
            </FormField>
        )}
    </Field>
);

export default DateFormikField;
